import React from "react";
import { connect } from "react-redux";
import { isLogged, isPublic } from "../../CroUtils";
import Help from "../Help";
import { isUndefined } from "lodash";

const CroLabeledCmp = ({
  required,
  title,
  labelStyle,
  divStyle,
  rowStyles = {},
  children,
  className,
  auth,
  helpEnum,
  ...fieldRest
}) => (
  <div className={"label cro-labeled-cmp " + className} style={divStyle}>
    <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
      <span
        className={
          required && isLogged(auth) && !isPublic(auth)
            ? "title required"
            : "title"
        }
        style={labelStyle}
      >
        {title}
      </span>
      {!isUndefined(helpEnum) && (
        <Help
          helpEnum={helpEnum}
          disabled={fieldRest.disabled}
          tooltipPosition="top-right"
          style={{ width: "20px", height: "20px" }}
        />
      )}
    </span>
    <div style={{ flexBasis: "100%", display: "flex", ...rowStyles }}>
      {children}
    </div>
  </div>
);

const mapStateToProps = (state) => ({
  auth: state.sidebar.auth,
});

export default connect(mapStateToProps)(CroLabeledCmp);
